import React from "react";
import * as styles from "./RaceOutcomes.module.scss";

export const Fav = () => <div className={styles.fav}>fav</div>;
